import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { DomainService, GivColumnDomain } from 'app/services/domain.service';
import { LayerCategoryStandardSchema } from 'app/services/field-mapping.service';
import { RCRecordItem, QaResolverFeed, ResoCenterCol, ResolutionCenterService, ResoCenterRule } from 'app/services/resolution-center.service';
import { RCCellChangeData } from '../rc-cell/rc-cell.component';

interface RCRecordItemExt extends RCRecordItem {
	domainsByColumn: {
		[prop: string]: GivColumnDomain;
	}
}

@Component({
  selector: 'app-resolution-asq',
  templateUrl: './resolution-asq.component.html',
  styleUrls: ['./resolution-asq.component.css', '../resolution-inspector/resolution-inspector.component.css']
})
export class ResolutionASQComponent implements OnInit, OnChanges {

	@Input() resolverFeed: QaResolverFeed;
	@Output() edit: EventEmitter<any> = new EventEmitter();
	
	addrList: RCRecordItemExt[] = [];
	cols: ResoCenterCol[] = [];
	rules: ResoCenterRule[] = [];

	constructor(
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private domainService: DomainService,
		private resoCenterService: ResolutionCenterService
	) { }

	clickAddress(addr: RCRecordItemExt) {
		this.addrList.forEach(a => a.isCurrent = a === addr);
	}
	switchLeftRight(idx) {
		const right = this.addrList[idx + 1];
		const tempProps = JSON.parse(JSON.stringify(right.props));
		this.cols.forEach(c => {
			right.props[c.prop] = this.addrList[idx].props[c.prop];
			this.addrList[idx].props[c.prop] = tempProps[c.prop];
		});
		this.cols.forEach(c => {
			this.resoCenterService.onEditRecord(right, c);
			this.resoCenterService.onEditRecord(this.addrList[idx], c);
		});
		this.edit.emit({
			changedCols: this.cols
		});
	}
	clickExcept() {}
	// switchLeft() {
	// 	const idx = this.addrList.findIndex(a => a.isCurrent);
	// 	const left = this.addrList[idx - 1];
	// 	const tempProps = JSON.parse(JSON.stringify(left.props));
	// 	this.cols.forEach(c => {
	// 		left.props[c.prop] = this.addrList[idx].props[c.prop];
	// 		this.addrList[idx].props[c.prop] = tempProps[c.prop];
	// 	});
	// 	this.cols.forEach(c => {
	// 		this.resoCenterService.onEditAddress(left, c);
	// 		this.resoCenterService.onEditAddress(this.addrList[idx], c);
	// 	});
	// }
	// switchRight() {
	// 	const idx = this.addrList.findIndex(a => a.isCurrent);
	// 	const right = this.addrList[idx + 1];
	// 	const tempProps = JSON.parse(JSON.stringify(right.props));
	// 	this.cols.forEach(c => {
	// 		right.props[c.prop] = this.addrList[idx].props[c.prop];
	// 		this.addrList[idx].props[c.prop] = tempProps[c.prop];
	// 	});
	// 	this.cols.forEach(c => {
	// 		this.resoCenterService.onEditAddress(right, c);
	// 		this.resoCenterService.onEditAddress(this.addrList[idx], c);
	// 	});
	// }

	onEdit(idx, e: RCCellChangeData) {
		// this.addrList[idx].props[e.col.prop] = e.val;
		this.resoCenterService.onEditRecord(this.addrList[idx], e.col);
		this.edit.emit({
			changedCols: [e.col]
		});
	}

	private async onFeedChange() {
		if (!this.resolverFeed) {
			this.addrList = [];
			this.cols = [];
			this.rules = [];
			return;
		}
		const layerCateCode = Object.keys(this.resolverFeed.feed)[0];
		//
		this.cols = await this.resoCenterService.transformCols(this.resolverFeed.feed[layerCateCode].cols, layerCateCode);
		this.rules = this.resoCenterService.transformRules(this.resolverFeed.rules);

		const addrList = await this.resoCenterService.transformItemList(this.resolverFeed, layerCateCode);
		addrList.sort((a, b) => {
			if (a.props[this.attrIndexService.addrAddNumCol] > b.props[this.attrIndexService.addrAddNumCol]) {
				return 1;
			} else if (a.props[this.attrIndexService.addrAddNumCol] < b.props[this.attrIndexService.addrAddNumCol]) {
				return -1;
			} else {
				return 0;
			}
		});
		// Add Domains
		const layerCate = this.activityService.selectedLayerBS.getValue().layer.category;
		const colsForDomain: {prop; standard: LayerCategoryStandardSchema}[] = this.cols.map(c => {
			return {
				prop: c.prop,
				standard: layerCate.standardCols.find(s => s.colName === c.standardName)
			}
		});
		this.addrList = addrList.map(i => {
			const domainsByColumn = this.domainService.getColumnDomains(colsForDomain, layerCate.code, i.props);
			return Object.assign(i, {
				domainsByColumn: domainsByColumn
			});
		});
	}

	async ngOnInit() {

	}
	async ngOnChanges(changes: SimpleChanges) {
		if (changes.resolverFeed) {
			await this.onFeedChange();
		}
	}

}
